import { Flex, IconButton } from '@utilitywarehouse/hearth-react';
import { SettingsMediumIcon } from '@utilitywarehouse/hearth-react-icons';

import { ConfigCatFeatureFlags } from '@components/Debug/ConfigCatFeatureFlags.tsx';
import {
  DialogID,
  DialogUnsynced,
  useDialogUnsynced,
} from '@components/Dialog';

const DIALOG_ID = DialogID.DEBUG;

const Menu = () => (
  <DialogUnsynced id={DIALOG_ID} heading="Debug">
    <Flex direction="column" gap="200" marginTop="200">
      <ConfigCatFeatureFlags />
    </Flex>
  </DialogUnsynced>
);

export const Debug = () => {
  const dialog = useDialogUnsynced(DIALOG_ID);

  return (
    <>
      <Menu />

      <Flex
        position="fixed"
        right="200"
        bottom="200"
        direction="column"
        zIndex="9999"
      >
        <IconButton
          label="Debug"
          size="md"
          variant="outline"
          colorScheme="destructive"
          onClick={() => dialog.setOpen(!dialog.open)}
        >
          <SettingsMediumIcon />
        </IconButton>
      </Flex>
    </>
  );
};
